import { orchestrator } from 'satcheljs';
import { logNewConsumerRecruitmentResponse } from '../actions/logNewConsumerRecruitmentResponse';
import { CaptureFeedbackDatapoint } from 'owa-feedback-common';

export default orchestrator(logNewConsumerRecruitmentResponse, async userResponse => {
    const keys: string[] = ['ncrfn', 'ncrue', 'ncrar', 'ncrpr'];

    let values: string[] = [
        userResponse.firstName,
        userResponse.userEmail,
        userResponse.ageResponse,
        userResponse.purposeResponse,
    ];

    await CaptureFeedbackDatapoint.import().then(captureFeedbackDatapoint => {
        captureFeedbackDatapoint({
            keys: keys,
            values: values,
        });
    });
});
